import { render, staticRenderFns } from "./deanThreeColumnLayout.vue?vue&type=template&id=1e7ebdee&scoped=true"
import script from "./deanThreeColumnLayout.vue?vue&type=script&lang=ts"
export * from "./deanThreeColumnLayout.vue?vue&type=script&lang=ts"
import style0 from "./deanThreeColumnLayout.vue?vue&type=style&index=0&id=1e7ebdee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7ebdee",
  null
  
)

export default component.exports